import { render, staticRenderFns } from "./NotificationPharmacyGroupsApprovalRequest.vue?vue&type=template&id=28594018"
import script from "./NotificationPharmacyGroupsApprovalRequest.vue?vue&type=script&lang=js"
export * from "./NotificationPharmacyGroupsApprovalRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports